import { render } from "./CometChatMessageComposer.vue?vue&type=template&id=0ac81fe4&scoped=true"
import script from "./CometChatMessageComposer.vue?vue&type=script&lang=js"
export * from "./CometChatMessageComposer.vue?vue&type=script&lang=js"

import "./CometChatMessageComposer.vue?vue&type=style&index=0&id=0ac81fe4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac81fe4"]])

export default __exports__